import React from 'react'
import { ButtonStyle } from './styles'
import { IconComponent } from '~/assets/icons/component'

export interface ButtonProps {
  pageNumber: string
  totalPages: number
  direction: 'forward' | 'backward'
  action: (direction: string) => void
}

export const Button = ({ pageNumber, totalPages, direction, action }: ButtonProps): JSX.Element => {
  const page = +pageNumber

  const onClick = (direction: string) => {
    if (direction === 'backward') {
      return page <= 1 ? {} : action(direction)
    }

    if (direction === 'forward') {
      return page >= totalPages ? {} : action(direction)
    }
  }

  return (
    <ButtonStyle
      data-testid="button"
      onClick={() => onClick(direction)}
      direction={direction}
      notAvailable={direction === 'backward' ? page <= 1 : page >= totalPages}
    >
      <IconComponent name="chevronDown" iconsize={16} />
    </ButtonStyle>
  )
}
